// extracted by mini-css-extract-plugin
export default {"form":"EditAnnouncementView_form__FSPfQ","error":"EditAnnouncementView_error__zPiCA"};